import { Component, OnInit } from '@angular/core';
import {Router} from '@angular/router';
import {paymentVaStorage} from '@storage/payment-va.storage';
import {NavigationConstant} from '@constant/navigation.constant';

@Component({
  selector: 'app-klik-bca-payment-result',
  templateUrl: './klik-bca-payment-result.component.html',
  styleUrls: ['./klik-bca-payment-result.component.css']
})
export class KlikBcaPaymentResultComponent implements OnInit {

  imageUrl = 'https://cdn-doku.oss-ap-southeast-5.aliyuncs.com/doku-ui-framework/doku/img/success.png';
  imagePath;
  moduleName;
  paymentResult = 'Success';
  isSuccess = true;
  failedReason;

  merchantCode: string;
  userId: string;
  transactionNo: string;
  transactionDate: string;
  status: string;
  reason: string;
  amount: string;

  constructor(
      private router: Router,
      private storage: paymentVaStorage
  ) { }

  ngOnInit(): void {
    if (this.storage.paymentResult == null) {
      this.router.navigate([NavigationConstant.KLIK_BCA_INQUIRY]);
    }
    this.populateData();
    this.displayResult();
  }

  goToInquiry() {
    this.router.navigate([NavigationConstant.KLIK_BCA_INQUIRY]);
  }

  populateData() {
    this.imagePath       = this.storage.imagePath;
    this.moduleName      = this.storage.moduleName;
    const paymentResult  = this.storage.paymentResult;

    this.merchantCode    = paymentResult.merchantCode;
    this.userId          = paymentResult.userId;
    this.transactionNo   = paymentResult.transactionNo;
    this.transactionDate = paymentResult.transactionDate;
    this.status          = paymentResult.status;
    this.reason          = paymentResult.reason;
    this.amount          = paymentResult.amount;
  }

  displayResult() {
    const statusCode = this.storage.paymentResult.status;
    if (statusCode === '01') {
      this.paymentResult = 'Failed';
      this.imageUrl = 'https://cdn-doku.oss-ap-southeast-5.aliyuncs.com/doku-ui-framework/doku/img/fail.png';
      this.isSuccess = false;
      this.failedReason = this.storage.paymentResult.responseMessage || 'Undefined Error';
    }
  }
}
